import { render, staticRenderFns } from "./Submitter.vue?vue&type=template&id=6118f5c4&scoped=true"
import script from "./Submitter.vue?vue&type=script&lang=js"
export * from "./Submitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6118f5c4",
  null
  
)

export default component.exports